import { useMemo } from 'react';

const BaseSteps = [{
  name: 'Business',
  routes: ['/onboarding/business-info'],
  step: 0,
  visible: true,
}];

const ClassicPaymentScheduleStep = {
  name: 'Payment Schedule',
  routes: ['/onboarding/payment-schedule', '/onboarding/demo-payment-schedule', '/onboarding/auto-get-paid-now', '/onboarding/pay-on-approval', '/onboarding/net-30-payment-schedule'],
  step: 1,
  visible: true,
};

const OnDemandPaymentScheduleStep = [{
  name: 'Payment Schedule',
  routes: ['/onboarding/on-demand-schedule'],
  step: 1,
  visible: true,
}];

const DefaultConfirmationSteps = [{
  name: 'Banking',
  routes: ['/onboarding/bank-info', '/onboarding/direct-debit-agreement', '/onboarding/acknowledge-direct-debit-agreement', '/onboarding/verify-bank', '/onboarding/bank-plaid'],
  step: 2,
  visible: true,
}, {
  name: 'Confirmation',
  description: 'Terms & Conditions',
  routes: ['/onboarding/review', '/onboarding/terms', '/onboarding/jll-terms'],
  step: 3,
  visible: true,
}];

const CustomMsaConfirmationSteps = [{
  name: 'Confirmation',
  routes: ['/onboarding/bank-info', '/onboarding/direct-debit-agreement', '/onboarding/acknowledge-direct-debit-agreement', '/onboarding/verify-bank'],
  // todo
  step: 3,
  visible: true,
}];

const OnDemandConfirmationSteps = [{
  name: 'Confirmation',
  routes: ['/onboarding/terms'],
  // todo
  step: 2,
  visible: true,
}];

type UseProgressBarStepsArgs = {
  onDemand: boolean;
  customMsa: boolean;
  includeOnDemandBankInfo?: boolean;
  directDebit: boolean;
};

function useProgressBarSteps({
  onDemand,
  customMsa,
  includeOnDemandBankInfo = true,
  directDebit,
}: UseProgressBarStepsArgs) {
  const stepContent = useMemo(() => [
    ...BaseSteps,
    ...([ClassicPaymentScheduleStep]),
    ...(customMsa ? CustomMsaConfirmationSteps : DefaultConfirmationSteps),
  ], [customMsa]);
  const odStepContent = useMemo(() => [
    ...BaseSteps,
    ...(OnDemandPaymentScheduleStep),
    ...(includeOnDemandBankInfo ? DefaultConfirmationSteps : OnDemandConfirmationSteps),
  ], [includeOnDemandBankInfo]);

  if (directDebit) {
    // do not show progress bar for direct debit
    return [];
  } else if (!onDemand) {
    return stepContent;
  } else {
    return odStepContent;
  }
}

export default useProgressBarSteps;
